const phrases = [
  "Plagiocefalia Posizionale",
  "Scansione Volumetrica Digitale",
  "Osteopatia Pediatrica",
  "Primi 24 mesi di vita",
  "12 ore di formazione",
  "Evidenze Scientifiche",
];

export const Marquee = () => {
  const row = [...phrases, ...phrases];
  return (
    <div className="relative py-6 border-y border-petrol/10 bg-cream/60 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl text-petrol/70 px-8">{p}</span>
                <span className="w-2 h-2 rounded-full bg-coral/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
